import { Capability } from "../charts";

export interface IAnalyticsV2Filters {
  entityType: EntityType;
  area: Area;
  host: Host;
  capability: Capability;
  os: OS;
  platform: Platform;
}

export interface IDependencyFilters {
  entityType?: boolean;
  area?: boolean;
  host?: boolean;
  capability?: boolean;
  os?: boolean;
  platform?: boolean;
}

// These enums is in parity with the fields provided By IKS
export enum EntityType {
  User = "Users",
  Tenant = "Tenants",
}

// ISO 3 Country code standard - https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
export enum Area {
  AllUp = "all",
  UnitedStates = "USA",
  WesternEurope = "WEU",
  LatinAmerica = "LAM",
  Japan = "JPN",
  India = "IND",
  Canada = "CAN",
  AustraliaAndNewZealand = "ANZ",
  UnitedKingdom = "GBR",
  France = "FRA",
  AsiaPacific = "APC",
  Germany = "DEU",
  Switzerland = "CHE",
  Korea = "KOR",
  Netherlands = "NLD",
  CentralEuropeAndMiddleEastAndAfrica = "CEM",
}

export enum Host {
  AllUp = "all",
  Teams = "teams",
  Outlook = "outlook",
  Harmony = "harmony",
  Copilot = "m365Copilot",
}

export enum OS {
  AllUp = "all",
  iOS = "iOS",
  Android = "android",
  Mac = "mac",
  Windows = "windows",
  Unknown = "unknown",
  ChromeOS = "chromeOS",
  Other = "other",
}

export enum Platform {
  AllUp = "all",
  Mobile = "mobile",
  Web = "web",
  Desktop = "desktop",
  Universal = "universal",
  Unknown = "unknown",
}

export enum Metric {
  Active = "TotalActive",
  New = "TotalNew",
  Returning = "TotalReturning",
  Lapsed = "TotalLapsed",
  Resurrected = "TotalResurrected",
  Median = "MedianDaysUsed",
  Percentage5Days = "PercentageOf5PlusDaysUsed",
  Ratio = "DauMauRatio",
}

export enum Group {
  OS = "OS",
  Platform = "Platform",
  Region = "Region",
  Host = "Host",
  Capability = "Capability",
}

export enum GroupName {
  UsageData = "usageData",
  OS = "usageData_OS",
  Platform = "usageData_Platform",
  Area = "usageData_Region",
  Host = "usageData_Host",
  HostCapability = "usageData_Capability_Host",
}

